import React, { useContext, useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import "./Cancel_Reason_Modal.css";
import Success_Modal_LogOut from "../success_modal/Success_Modal_logOut";
import Gray_Btn from "../../common_btn/gray_btn/Gray_Btn";
import Green_btn from "../../common_btn/green_btn/Green_btn";

function Cancel_Reason_Modal({
  data,
  cancelReason,
  setCancelReason,
  setOtherReason,
  otherReason,
  onSaveExit,
  onCancel,
  cancelReasons,
  ...props
}) {
  const { show, onHide, modal_title } = props;
  const [showSuccess, setShowSuccess] = useState(false);
  const reasons = [
    "Product price has reduced",
    "Wrong contact number entered",
    "Ordered by mistake",
    "Incorrect product size/colour/type ordered",
    "Product price has reduced",
    "Wrong contact number entered",
    "Ordered by mistake",
    "Incorrect product size/colour/type ordered",
  ];

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        className="Cancel_Reason_Modal Modal-holder"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{modal_title}Select a reason for cancelling order</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="select_reason">
            <Form>
              {cancelReasons?.map((value, index) => (
                <Form.Check
                  key={value?.id || index}
                  label={value?.name}
                  value={value?.id}
                  name="order_cancel_reason_id"
                  type="radio"
                  className="mini-text"
                  checked={cancelReason === value?.id}
                  onChange={() => {
                    setCancelReason(value?.id);
                  }}
                />
              ))}

              {/* OTHER OPTION */}
              <Form.Check
                label="Other"
                value="other"
                name="order_cancel_reason_id"
                type="radio"
                className="mini-text"
                checked={cancelReason === "other"}
                onChange={() => {
                  setCancelReason("other");
                }}
              />

              {/* OTHER TEXT FIELD */}
              {cancelReason === "other" && (
                <Form.Group className="mt-2">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    maxLength={200}
                    placeholder="Please tell us the reason"
                    value={otherReason}
                    onChange={(e) => {
                      setOtherReason(e.target.value);
                    }}
                  />

                  <div
                    style={{
                      textAlign: "right",
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "4px",
                    }}
                  >
                    {otherReason?.length}/200
                  </div>
                </Form.Group>
              )}
            </Form>

            <div className="bottom_btns">
              <Green_btn
                btnText={"Cancel Order"}
                disabled={
                  !cancelReason ||
                  (cancelReason === "other" && !otherReason?.trim())
                }
                onClick={onSaveExit}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Cancel_Reason_Modal;
